export enum Subtree {
  Content = '/1/2/160/',
  Media = '/1/43/',
  Authors = '/1/2/35844/',
  App = '/1/2/249932/',
  Login = '/1/2/249932/269575/',
}
